if (!customElements.get("m-hotspot")) {
  class Hotspot extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        wrapper: ".m-hotspots-image__wrapper",
        card: ".m-hotspot__card",
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.wrapper = this.closest(this.selectors.wrapper);
      this.card = this.domNodes.card;

      if (!this.card) return;

      // Shared modal for all hotspots in this section (reused per section)
      if (!this.wrapper._hotspotModal) {
        this.wrapper._hotspotModal = new MinimogTheme.Modal();
      }
      this.modal = this.wrapper._hotspotModal;

      this.icon = this.querySelector(".m-hotspot__icon");
      if (this.icon) {
        this.icon.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openModal();
        });
      }
      // Also allow click on the icon-point (the + circle) if present
      this.addEventListener("click", (e) => {
        if (e.target.closest(".m-hotspot__icon")) return; // already handled above
        e.preventDefault();
        this.openModal();
      });
    }

    openModal() {
      if (!this.modal || !this.card) return;

      this.modal.innerHTML = "";

      const content = document.createElement("div");
      content.className = "m-hotspot-popup__content m-richtext m-gradient m-color-default";
      content.innerHTML = this.card.innerHTML;

      const inner = document.createElement("div");
      inner.className = "m-hotspot-popup__inner";
      inner.appendChild(content);

      this.modal.appendChild(inner);
      this.modal.setSizes("m-hotspot-popup m-gradient m-color-default");
      this.modal.open();
    }
  }
  customElements.define("m-hotspot", Hotspot);
}
